module.exports = __webpack_public_path__ + "img/4.1fd1c94e.jpg";